import type { FetcherAxiosInstance } from '../fetcher';

export const createMediaBannersApi = (Fetcher: FetcherAxiosInstance) => ({
  fetchMediaBanners({ slots, categoryId }: { slots: string, categoryId: string}) {
    return Fetcher(`/media/banners/${slots}`, {
      params: {
        categories: [categoryId],
      },
    });
  },
});
